import { useSelector, useDispatch } from 'react-redux'
import {
    setUser,
    initialState,
    setLang,
    setUserDetails,
    setCompanyDetails,
    setDepartment,
    setFinancialYear,
    setNavigation,
} from 'store/auth/userSlice'
import {
    apiSignIn,
    apiSignOut,
    apiSignUp,
    apiGetUser,
    apiGetLang,
    apiGetUserDetails,
    apiGetDepartmentName,
    apiGetFinancialYear,
    apiGetCompany,
    apiGetNavigation,
} from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
            const resp = await apiSignIn(values)
            console.log(resp.data)
            if (resp.data) {
                const { token } = resp.data
                console.log(token)
                dispatch(onSignInSuccess(token))
                const user = await apiGetUser()
                console.log(user)
                if (user.data) {
                    dispatch(
                        setUser({
                            avatar: user.data.user_image,
                            userName: user.data.comn_user_name,
                            authority: ['user'],
                            email: user.data.email_id,
                            userCode: user.data.comn_user_code,
                            userAlias: user.data.comn_user_alias,
                            groupCode: user.data.comn_user_group_code,
                            userStatus: user.data.comn_user_status,
                        })
                    )
                    // const lang = await apiGetLang()
                    // dispatch(setLang(lang))
                    // const userDetails = await apiGetUserDetails()
                    // dispatch(setUserDetails(userDetails))
                    // const company = await apiGetCompany()
                    // dispatch(setCompanyDetails(company))
                    // const department = await apiGetDepartmentName()
                    // dispatch(setDepartment(department))
                    // const financialYear = await apiGetFinancialYear()
                    // dispatch(setFinancialYear(financialYear))
                    // const navigation = await apiGetNavigation()
                    // dispatch(setNavigation(navigation))
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        // await apiSignOut()
        handleSignOut()
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signUp,
        signOut,
    }
}

export default useAuth
